// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main_Main__2MxY7","BreakLine":"Main_BreakLine__1CA5n"};